export const REPAIR_TEST_MODE_KEY = "FQ_ENABLE_REPAIR_TEST_MODE";

export function readRepairTestMode(storage) {
  try { return storage?.getItem(REPAIR_TEST_MODE_KEY) === "1"; }
  catch (error) { return false; }
}

export function setRepairTestMode(storage, enabled) {
  if (enabled) storage.setItem(REPAIR_TEST_MODE_KEY, "1");
  else storage.removeItem(REPAIR_TEST_MODE_KEY);
}

export function canUseRepairFixtures({ allowed, isSuperAdmin, testModeEnabled }) {
  return Boolean(allowed && (isSuperAdmin || testModeEnabled));
}

export function summarizeRepairFields(values = {}) {
  if (!values || typeof values !== "object") return "No field summary recorded.";
  const fields = Object.keys(values.patch || values).filter((key) => !["mode", "selectedFields", "readbackExists"].includes(key));
  return fields.length ? fields.slice(0, 8).join(", ") + (fields.length > 8 ? ` (+${fields.length - 8} more)` : "") : "No changed fields recorded.";
}

// Preserve existing tagged fixtures; never replace an untagged deterministic ID.
export function createRepairFixtureBatch({ db, runTransaction, onRead }) {
  const records = [];
  return {
    set(ref, data) { records.push({ ref, data }); },
    async commit() {
      return runTransaction(db, async (transaction) => {
        const snapshots = [];
        for (const { ref, data } of records) {
          if (data.repair_test_data !== true) throw new Error("Fixture payload must be tagged.");
          const snapshot = await transaction.get(ref);
          onRead?.({ path: ref.path, label: "crmDataRepair.fixtureCreation.tagCheck", kind: "transaction.get", stack: new Error().stack });
          if (snapshot.exists() && snapshot.data().repair_test_data !== true) throw new Error("A fixture ID belongs to an untagged record. Nothing was changed.");
          snapshots.push(snapshot);
        }
        records.forEach(({ ref, data }, index) => {
          if (!snapshots[index].exists()) transaction.set(ref, data);
        });
      });
    },
  };
}
